import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCW6X3TS1EK4SOwbig5yTD-YJOevxnxRlA",
  authDomain: "ab-gym.firebaseapp.com",
  projectId: "ab-gym",
  storageBucket: "ab-gym.appspot.com",
  messagingSenderId: "102870993678",
  appId: "1:102870993678:web:5e8f87fe985a158888e55f",
  measurementId: "G-E7FGZMKCVH",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

export { db, auth };
